// extracted by mini-css-extract-plugin
export default {"iconBlock":"MobileViewerDoc__iconBlock--1jGYt"};